import sidebar from '@/data/sidebar';
import { CHART_GROUPS, CHARTS_MENU_TO, flattenChartItems } from '@/data/charts';
import { chartItemScopes } from '@/utils/charts/access';
import { SALES_TEAM_POSITIONS } from '@/data/sales-team-positions';

export const buildViewSections = () => {
    const sections = sidebar.links
        .filter((link) => link.path !== CHARTS_MENU_TO)
        .map((link) => {
            if (link.children?.length) {
                return {
                    title: link.name,
                    items: link.children.map((child) => ({
                        id: child.path,
                        title: child.name,
                        to: child.path,
                        icon: link.icon,
                        scopes: child.scope,
                        bypassPositions: child.bypassPositions,
                    })),
                };
            }
            return {
                title: link.name,
                items: [
                    {
                        id: link.path,
                        title: link.name,
                        to: link.path,
                        icon: link.icon,
                        scopes: link.scope,
                    },
                ],
            };
        });

    sections.push({
        title: 'Charts',
        items: [
            {
                id: 'charts',
                title: 'Charts',
                to: CHARTS_MENU_TO,
                icon: 'ri-line-chart-line',
                scopes: ['read_charts'],
                bypassPositions: SALES_TEAM_POSITIONS,
            },
            ...flattenChartItems(CHART_GROUPS)
                .filter((item) => item.to)
                .map((item) => ({
                    id: `chart:${item.id}`,
                    title: item.title,
                    to: item.to,
                    icon: item.icon || 'ri-line-chart-line',
                    scopes: chartItemScopes(item),
                    bypassPositions: item.bypassPositions,
                })),
        ],
    });

    if (sidebar.otherLinks?.length) {
        sections.push({
            title: 'More',
            items: sidebar.otherLinks.map((item) => ({
                id: item.path,
                title: item.name,
                to: item.path,
                icon: item.icon,
            })),
        });
    }

    return sections;
};

export const buildChartBrowseSections = () =>
    CHART_GROUPS.map((group) => ({
        title: group.title,
        items: group.items
            .filter((item) => item.to)
            .map((item) => ({
                id: `chart:${item.id}`,
                title: item.title,
                to: item.to,
                scopes: chartItemScopes(item),
                bypassPositions: item.bypassPositions,
            })),
    }));
